import React from 'react';
import styled from 'styled-components';
import SGButton from 'components/CTA/SGButton';
import {useHistory, useParams} from 'react-router-dom';
import {DeviceWithLocation} from '../interfaces/DeviceResponse';
import getSwitchURL from '../functions/getSwitchURL';

const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

const StyledSGButton = styled(SGButton)`
  border-radius: 10px;
  padding: 8px 70px;
  margin-left: auto;
`;

interface ViewSelectionButtonProps {
  selectedDevices: DeviceWithLocation[];
}

function ViewSelectionButton({selectedDevices}: ViewSelectionButtonProps) {
  const {urlKey} = useParams<any>();
  let history = useHistory();

  const handleClick = () => {
    const switchURL = getSwitchURL({urlKey, selectedDevices});
    history.push(switchURL);
  };

  return (
    <ButtonContainer>
      <StyledSGButton onClick={() => handleClick()} disabled={selectedDevices.length === 0}>
        View Selection
      </StyledSGButton>
    </ButtonContainer>
  );
}

export default ViewSelectionButton;
